import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import Loader from "@components/Loader/Loader";
import { useNavigate } from "react-router-dom";

const AuthGuard: FC<{
  children: React.ReactElement;
  authenticated?: boolean;
}> = ({ children, authenticated = true }) => {
  const userLoggedIn = useSelector(
    (state: RootState) => state.auth.user !== null,
  );
  const isLoading = useSelector((state: RootState) => state.auth.isLoading);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (userLoggedIn && !authenticated) {
      navigate("/");
      return;
    }
    if (!userLoggedIn && authenticated) {
      navigate("/sign-in");
      return;
    }
  }, [userLoggedIn, authenticated, navigate, isLoading]);

  if (!userLoggedIn && isLoading) {
    return <Loader />;
  }

  if (!userLoggedIn && authenticated) {
    return null;
  }
  if (userLoggedIn && !authenticated) {
    return null;
  }
  return children;
};

export default AuthGuard;
